export const formatDuration = (durationString: string): string => {
  const regex = /^(\d*)(:?)([0-5][0-9]):([0-5][0-9])$/;

  const result = regex.exec(durationString);
  if (result && result.index === 0) {
    const [, HH, , mm, ss] = result;
    let formattedDuration = '';
    if (parseInt(HH, 10) > 0) {
      formattedDuration = `${HH}:`;
    }
    formattedDuration += `${mm}:${ss}`;
    return formattedDuration;
  } else {
    throw new Error(`${durationString} has not a valid format`);
  }
};
